// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgGasIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12.63 2.22a1 1 0 0 0-1.26 0C11.15 2.4 6 6.608 6 11.997s5.15 9.596 5.37 9.776a1 1 0 0 0 1.26 0c.22-.18 5.37-4.388 5.37-9.776 0-5.389-5.15-9.597-5.37-9.777M12 19.994a8.48 8.48 0 0 1-2-4.998 8.48 8.48 0 0 1 2-4.999 8.48 8.48 0 0 1 2 4.999 8.48 8.48 0 0 1-2 4.998"
    />
  </g>
);
export default SvgGasIcon;
SvgGasIcon.displayName = 'SvgGasIcon';
